import { useNavigate } from 'react-router-dom';

import { Button, Container } from './styles';
import { useState } from 'react';
import { StatusModalConfirmClick } from '../StyledModalConfirmClick';
import { useUser } from '../../context/UserContext';
import { removeRefreshTokenCache, removeTokenCache } from '../../services/api';

export const Header = () => {
  const { logout, user } = useUser();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const handleToNavigateTOLogin = () => {
    removeTokenCache();
    removeRefreshTokenCache();

    if (typeof window !== 'undefined') {
      window.location.href = '/login';
    }
  };

  const handleToLogout = () => {
    setShowModal(true);
  };

  return (
    <Container>
      <div className="welcomeContainer"></div>
      {showModal && (
        <StatusModalConfirmClick
          type="question"
          text="Deseja realmente sair?"
          setModal={setShowModal}
          twoButtons={true}
          callActions={[logout, handleToNavigateTOLogin]}
        />
      )}
      <p>Olá, {user?.name?.split(' ')[0]}</p>
      <Button onClick={handleToLogout}>Clique aqui para SAIR.</Button>
    </Container>
  );
};
